import React from "react";
import {Collapse,Row, Col, Button, Input, message, Tabs, Modal} from "antd";
import LoadingIndicator from "components/LoadingIndicator";
import {
    setupSchedule,
    submitDocumentCorporateAccount,
    updateCustomerAccountMyInfo,
    submitMyInfo,
    updateCustomerAccount, upload, deleteFile
} from "../api/api";
import {displayGenericError} from "../common/notifications";
import UploadWrapper from "./UploadWrapper";
import FieldValueVerticalCell from "./general/FieldValueVerticalCell";
import moment from "moment";


const { Panel } = Collapse;

export default class CustomerAcceptanceIndividualForm extends React.Component {
    state = {
        occupationName: this.props.occupationName,
        industryName: this.props.industryName,
        isMyInfo: this.props.isMyInfo,
        dateSelect: '',
        selectTime: '',
        onboardingType: '',
        selfieImgLink:'',
        documents:{},
        documentType:'',
        isLoading: false,
    };

    componentWillReceiveProps(nextProps) {
        if(!this.props.isMyInfo){
            if (nextProps.onboardingData != null) {
                this.setState({
                    dateSelect: nextProps.onboardingData.dateSelect,
                    selectTime: nextProps.onboardingData.timeSelect,
                    onboardingType: nextProps.onboardingData.onboardingType,
                    selfieImgLink: nextProps.onboardingData.selfieImgLink,
                    documents: nextProps.onboardingData.documents,
                    documentType: nextProps.onboardingData.documentType,
                    isLoading: false
                },()=>{
                    let documentType = this.state.documentType ;
                    if(documentType != null){
                        let documentLabel = documentType.toUpperCase() ;
                        this.setState({ documentLabel : documentLabel })
                    }
    
                })
            }
        }
    }
/*
    componentDidMount() {
        if(this.props.isMyInfo){
            retrieveMyInfo(this.props.myinfoCode).then(response =>{
                this.setState({
                    isLoading: false
                })
            })
        }
    }
*/
    handleSubmit = () => {
        if (this.props.isMyInfo) {
            let myInfo = this.props.myInfo;
            myInfo.authorisationCode=this.props.myinfoCode;
            this.props.customerAccount.myInfoResource = myInfo;

            updateCustomerAccountMyInfo(this.props.customerAccount)
                .then(() => {
                    message.info(
                        "Thank you for verifying, your account review will be completed soon"
                    );
                    this.setState({
                        isSubmitted: true,
                    })
                    this.props.nextTab({
                        isSubmitted: true,
                    });
                })
                .catch(displayGenericError);
        } else {
            if (this.state.onboardingType === 'timeSchedule') {
                setupSchedule({dateSelect: this.state.dateSelect, timeSelect: this.state.selectTime}).then(() => {
                    submitDocumentCorporateAccount(this.state.onboardingType)
                        .then(() => {
                            message.info(
                                "Thank you for verifying, your account review will be completed soon"
                            );
                            this.setState({
                                isSubmitted: true,
                            })
                            this.props.nextTab({
                                isSubmitted: true,
                            });
                        })
                        .catch(displayGenericError);
                }).catch(displayGenericError);
            } else if (this.state.onboardingType === 'selfie') {
                submitDocumentCorporateAccount(this.state.onboardingType)
                    .then(() => {
                        message.info(
                            "Thank you for verifying, your account review will be completed soon"
                        );
                        this.setState({
                            isSubmitted: true,
                        })
                        this.props.nextTab({
                            isSubmitted: true,
                        });
                    })
                    .catch(displayGenericError);
            }
        }

    };

    handleUpload = ({file, type, index}) => {
        if (!(typeof index === "number")) {
            return upload({id: this.props.customerAccount.id, file, type})
                .then(res => {
                    this.setState({
                        documents: {
                            ...this.state.documents,
                            [type]: {
                                name: file.name,
                                size: file.size / 1024,
                                id: res.id
                            }
                        }
                    });
                })
                .catch(displayGenericError);
        }
    };

    handleRemoveFile = ({id, type, index}) => {
        deleteFile(id)
            .then(() => {
                if (!(typeof index === "number")) {
                    const {documents} = this.state;
                    delete documents[type];
                    this.setState({documents});
                }
            })
            .catch(displayGenericError);
    };

    buildMyInfoData = (myInfo) => {
        const colStyle = {
            borderLeft: "0px",
            paddingLeft: "0px"
        }
        const rowStyle = {
            margin: "0px"
        }

        return (
            <div>
                <div className="profile-page-body">
                    <div className="personal-profile">
                        <h5 className={"fw-600"}>Personal Information</h5>
                        <div className="bp-bordered-panel">
                            <Row style={rowStyle}>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="Reference ID"
                                        value={myInfo.nricFin}
                                    />
                                </Col>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="Principal Name"
                                        value={myInfo.principalName}
                                    />
                                </Col>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="Alias Name"
                                        value={myInfo.aliasName}
                                    />
                                </Col>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="Hanyu Pinyin Name"
                                        value={myInfo.hanyuPinyinName}
                                    />
                                </Col>
                            </Row><Row style={rowStyle}>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="Hanyu Pinyin Alias Name"
                                        value={myInfo.hanyuPinyinAliasName}
                                    />
                                </Col>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="Sex"
                                        value={myInfo.sexDesc}
                                    />
                                </Col>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="Race"
                                        value={myInfo.raceDesc}
                                    />
                                </Col>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="DOB"
                                        value={moment(myInfo.dob).format("DD/MM/YYYY")}
                                    />
                                </Col>
                            </Row>
                            <Row style={rowStyle}>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="Nationality"
                                        value={myInfo.nationalityDesc}
                                    />
                                </Col>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="Pass Type"
                                        value={myInfo.passTypeDesc}
                                    />
                                </Col>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="Pass Status"
                                        value={myInfo.passStatus}
                                    />
                                </Col>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="Pass Expiry Date"
                                        value={myInfo.passExpiryDate}
                                    />
                                </Col>
                            </Row><Row style={rowStyle}>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="Occupation"
                                        value={myInfo.occupation}
                                    />
                                </Col>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="Name of Employer"
                                        value={myInfo.nameOfEmployer}
                                    />
                                </Col>
                                <Col style={colStyle} xs={12} lg={6} sm={12}>
                                </Col>
                                <Col style={colStyle} xs={12} lg={12} sm={12}>
                                </Col>
                            </Row>
                        </div>
                        <h5 className={"fw-600"}>Personal Address</h5>
                        <div className="bp-bordered-panel">
                            <Row>
                                <Col xs={24} lg={24} sm={24}>
                                    <FieldValueVerticalCell
                                        className="bp-table-cell"
                                        title="Registered Address"
                                        value={myInfo.registeredAddress}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>


            </div>
        );
    }
    render() {
        const {customerAccount} = this.props;
        const {isLoading} = this.state;
        
        if (isLoading) {
            return <LoadingIndicator />;
        }
        return (
            <div className="form--customer-acceptance">
                <h2 style={{paddingLeft: '5px', whiteSpace: 'nowrap'}}>General Individual Information</h2>
                <div style={{marginLeft: '5px'}}>
                    <Row gutter={24}>
                        <Col className="gutter-row" span={12}>
                            <label>First Name</label>
                            <input value={customerAccount.personalAccountDetails.firstName} disabled/>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <label>Last Name</label>
                            <input value={customerAccount.personalAccountDetails.lastName} disabled/>
                        </Col>
                    </Row>


                    <Row gutter={24}>
                        <Col className="gutter-row" span={12}>
                            <label>Address</label>
                            <input value={customerAccount.personalAccountDetails.addressLine1} disabled/>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <label>Contact Number</label>
                            <input value={customerAccount.personalAccountDetails.contactNumber} disabled/>
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col className="gutter-row" span={12}>
                            <label>Company</label>
                            <input value={customerAccount.personalAccountDetails.company} disabled/>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <label>Occupation</label>
                            <input value={this.props.occupationName} disabled/>
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col className="gutter-row" span={12}>
                            <label>Industry</label>
                            <input value={this.props.industryName} disabled/>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <label>Website</label>
                            <input value={customerAccount.personalAccountDetails.website} disabled/>
                        </Col>
                    </Row>


                    <Row gutter={24}>
                        <Col className="gutter-row" span={12}>
                            <label>Annual Salary</label>
                            <input value={customerAccount.personalAccountDetails.annualSalary} disabled/>
                        </Col>
                        <Col className="gutter-row" span={12}>
                            <label>Source of wealth</label>
                            <input value={customerAccount.personalAccountDetails.sourceOfFunds} disabled/>
                        </Col>
                    </Row>
                    {this.props.isMyInfo && (
                        <>
                            <h2 style={{paddingLeft: '5px', whiteSpace: 'nowrap'}}>Documents Upload</h2>
                            <Collapse defaultActiveKey={['1']} onChange={() => {
                            }} style={{marginBottom: 16}}>
                                <Panel key="1">
                                    <Row gutter={24}>
                                        <div id="id_front_div">
                                            <UploadWrapper
                                            id = "id_card_front"
                                                upload={this.handleUpload}
                                                file={
                                                    (this.state.documents && this.state.documents[
                                                        "IDENTITY_CARD_FRONT"
                                                        ]) || null
                                                }
                                                title="Identity Card (Front)"
                                                type="IDENTITY_CARD_FRONT"
                                                disabled={false}
                                                handleRemoveFile={this.handleRemoveFile}
                                            />

                                            <UploadWrapper
                                            id = "id_card_back"
                                                upload={this.handleUpload}
                                                file={
                                                    (this.state.documents && this.state.documents[
                                                        "IDENTITY_CARD_BACK"
                                                        ]) || null
                                                }
                                                title="Identity Card (Back)"
                                                type="IDENTITY_CARD_BACK"
                                                disabled={false}
                                                handleRemoveFile={this.handleRemoveFile}
                                            />

                                        </div>
                                    </Row>
                                </Panel>
                            </Collapse>
                        </>
                    )
                    }

                    <h2 style={{paddingLeft: '5px', whiteSpace: 'nowrap'}}>Document Information & Verification Method {this.state.isMyInfo ? ": MyInfo": ""}</h2>
                    {this.props.isMyInfo ? this.buildMyInfoData(this.props.myInfo) :
                        (
                            <>
                                <Row gutter={24}>
                                    <Col className="gutter-row" span={12}>
                                        <label>Document
                                            Type: {this.state.isMyInfo ? "MyInfo" : this.state.documentLabel}</label>

                                    </Col>
                                    <Col className="gutter-row" span={12} style={{paddingRight:20}}>
                                        {(this.state.documentType === 'passport') && (
                                            <div>
                                                <UploadWrapper
                                                    upload={this.handleUpload}
                                                    file={
                                                        this.state.documents[
                                                            "PASSPORT"
                                                            ]
                                                    }
                                                    title="Passport"
                                                    type="PASSPORT"
                                                    disabled={true}
                                                />
                                                <UploadWrapper
                                                    upload={this.handleUpload}
                                                    file={
                                                        this.state.documents[
                                                            "PROOF_OF_ADDRESS"
                                                            ]
                                                    }
                                                    title="Proof of Residential Address"
                                                    type="PROOF_OF_ADDRESS"
                                                    disabled={true}
                                                />
                                            </div>
                                        )}
                                        {(this.state.documentType === 'identityCard') && (
                                            <div id = "div_id">
                                                <UploadWrapper
                                                id = "id_card_f"
                                                    upload={this.handleUpload}
                                                    file={
                                                        this.state.documents[
                                                            "IDENTITY_CARD_FRONT"
                                                            ]
                                                    }
                                                    title="Identity Card (Front)"
                                                    type="IDENTITY_CARD_FRONT"
                                                    disabled={true}
                                                />

                                                <UploadWrapper
                                                id = "id_card_b"
                                                    upload={this.handleUpload}
                                                    file={
                                                        this.state.documents[
                                                            "IDENTITY_CARD_BACK"
                                                            ]
                                                    }
                                                    title="Identity Card (Back)"
                                                    type="IDENTITY_CARD_BACK"
                                                    disabled={true}
                                                />

                                                <UploadWrapper
                                                    upload={this.handleUpload}
                                                    file={
                                                        this.state.documents[
                                                            "PROOF_OF_ADDRESS"
                                                            ]
                                                    }
                                                    title="Proof of Residential Address"
                                                    type="PROOF_OF_ADDRESS"
                                                    disabled={true}
                                                />
                                            </div>
                                        )}
                                    </Col>
                                </Row>

                                <Row gutter={24}>
                                    <Col className="gutter-row" span={12}>
                                        {(this.state.onboardingType === 'timeSchedule') && (
                                            <label>
                                                Verification Method: Video Call
                                            </label>)}

                                        {(this.state.onboardingType === 'selfie') && (
                                            <label>
                                                Verification Method: Webcam Selfie
                                            </label>)}

                                    </Col>
                                    <Col className="gutter-row" span={12}>
                                        {(this.state.onboardingType === 'timeSchedule') && (
                                            <label>{this.state.dateSelect} {this.state.selectTime}</label>
                                        )}
                                        {(this.state.onboardingType === 'selfie') && (
                                            <label> <img src={this.state.selfieImgLink}
                                                         className="image-responsive"/></label>
                                        )}
                                    </Col>
                                </Row>
                            </>
                        )}


                    <Row gutter={24}>
                        <Col style={{textAlign: 'center'}}>
                            <Button className="bt-skip" onClick={this.props.prevTab}>
                                Back
                            </Button>
                            <Button
                                className="bt-next"
                                type="primary"
                                onClick={this.handleSubmit.bind(this)}>
                                Confirm
                            </Button>
                        </Col>
                    </Row>

                </div>


            </div>
        )
    }
}
